<template>
  <div class="board_wrap">
    <div class="board_title">
      <h1>ERP 시스템</h1>
    </div>
    <div class="product">
      <div>
        <h1>무역, 물류 관리 시스템</h1>
        &middot; &nbsp; 무역, 물류 기업용 ERP 시스템
      </div>

      <div>
        <h1>무역, 물류 관리 시스템 기능</h1>
        <table class="tg" style="undefined;table-layout: fixed; width: 950px">
          <colgroup>
            <col style="" />
          </colgroup>
          <thead>
            <tr>
              <th class="tg-dvsc">모듈명</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="tg-o57c" v-for="(item, tag) in name" :key="tag">
                <a :href="'#' + tag"> {{ item }}</a>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
      </div>
      <div>
        <h1>무역, 물류 관리 시스템 프로세스</h1>
        <p>
          1) 구매<br />
          <img src="../../../image/page/1004.jpg" />
        </p>
        <p>
          2) 영업<br />
          <img src="../../../image/page/1005.jpg" />
        </p>
        <p>
          3) 자재<br />
          <img src="../../../image/page/1006.jpg" />
          <br />
        </p>
        <p>
          4) 바코드<br />
          <img src="../../../image/page/1003.jpg" />
        </p>
      </div>
      <FormTable :info="info"></FormTable>
    </div>
  </div>
</template>

<script>
import FormTable from '../../static/FormTable.vue'
export default {
  components: { FormTable },
  data() {
    return {
      name: ['기초 등록', '수주', '구매의뢰/예약', '발주', '수/출입 관리', '입고', '출고', '허브창고', '창고이동', 'OFFER 관리', '수금', '종합인쇄', '견적 및 계획', '기타 관리', '수지예산'],
      info: [
        {
          subject: '기초정보',
          element:
            '품목분류별코드관리, 품목코드 관리, 업체 코드 관리, 초기자료 및 환경설정, 분류/발주업체 등록, 기초 이월 자료 입력, 업체별 단가 관리, 일자별 환율 적용, 일련번호 등록 관리. 각종 구분 코드 관리, 사원 코드 등록 관리, 각종 코드 변경 작업, 재고 실사 조정 작업, 사용자 관리 번호 등록, 프린트 양식 초기화, 각종 양식 설정, 회계 년도 등록, 사업장 코드 등록, 사업장 변경 작업,품목 위치코드 등록',
        },
        {
          subject: '수주',
          element:
            '수주 자료 입력, 수주 단위별 검색, 수주 세부 검색,수주자료 구매의뢰, 수주 밎정리분 완결 정리, 미납품 현황, 수주 자료 대장, 출고 예정 현황, 수주 진행 현황, EXCEL 수주 자료 등록, EXCEL 수주 납기 일자 변경, 바코드 BOX 작업,바코드 출고 작업, LOT 번호별 입출고 현황,출하 바코드 오류검증,출하 바코드 검증현황, 바코드 선입선출 내역, 출고요청 신규입력, 출고요청 검색정정',
        },
        {
          subject: '구매의뢰/예약',
          element:
            '구매의뢰 자료입력, 구매의뢰 검색정정, 구매의뢰 세부검색, 예약자료 신규입력, 예약자료 검색정정, 기간별 예약 진행현황, 예약 미정리분 완결정리, 기간별 구매의뢰 현황, 품목별 구매의뢰 현황',
        },
        {
          subject: '발주',
          element:
            '발주 자료 입력, 발주 단위별 검색, 발주 세부 검색, 구매의뢰 발주정리, 발주 미정리분 완결 정리, 구매의뢰 발주취소 내역, 미입고 현황, 발주 자료 대장, 입고 예정 현황, 발주 납기 현황 관리, 발주 기준 수주/예약 현황 ',
        },
        {
          subject: '수입 관리',
          element:
            '발주자료 L/C 요청, 수입 L/C 번호 등록, 수입 L/C 단위 검색, 수입 L/C 세부 검색, 수입 L/C 자료 대장, 수입 L/C 잔액 원장, 수입 B/L 미결 잔액, 수입 B/L 등록 작업, 수입 B/L 검색 정정, B/L 결제/비용 등록, B/L 결제 비용 검색, 수입 B/L 자료 대장, 수입 미선적 내역서, 수입 미통관 내역서, LOCAL L/C 내역서',
        },
        {
          subject: '수출 관리',
          element: '수주자료 L/C 등록,  수출 L/C 검색 정정, 수출 L/C 단위 검색, 수출 L/C 세부 검색, 수출 L/C 자료 대장, 수출 S/R 등록 작업, 수출 S/R 검색 정정, 수출 S/R 자료 대장',
        },
        {
          subject: '입고',
          element:
            '입고 신규 입력, 입고 자료 검색, 기간별 입고현황, 매입처별 입고현황, 품목별 입고현황, RMA 미입고/완결정리, 거래처별 매입확정 정리, 매입계산서 회계이체 작업, 내국신용장 물품수령 증명, 수입 B/L 바코드 입고정리, 발주자료 바코드 입고정리, 바코드 입고 작업(구)',
        },
        {
          subject: '출고',
          element:
            '출고 신규 입력, 출고 자료 검색,전용 출고 입력, 전용 출고 검색, 기간별 출고 현황, 매출처별 출고현황, 품목별 출고현황, 출고 요청자료 검색/정정, EXCEL 품목재고 자료조회, 거래명세서 출력, 거래처별 매출확정 정리, 매출확정분 검색/출력, 세금계산서 회계이체 작업, 원가 결산 관리, 월별 재고 분석표, 업체별 매입/매출 현황표, EXCEL 기타 입출고 등록, 매입처별 매출 현황표, 출고요청 바코드 출고정리, 출고전용 바코드 입고정리, S/R요청 바코드 출고정리',
        },
        {
          subject: '허브 창고',
          element: '허브 창고 출고 입력, 허브 창고 출고 검색, 기간별 허브 창고 출고 현황, 허브 창고별 출고 현황, 품목별 허브 창고 출고 현황, 허브 창고별 종합 재고 현황, EXCEL 허브창고 출고 등록',
        },
        {
          subject: '창고이동',
          element:
            '창고이동 신규입력, 창고 이동 검색정정기간별 창고이동 현황, 품목별 이동 현황, 창고별 이동 현황, 창고별 입출고 원장, 창고 재고 현황, EXCEL 창고 이동 등록, 업체별 재고 현황, LOT번호별 재고현황',
        },
        {
          subject: 'OFFER 관리',
          element: 'OFFER 수주 관리, OFFER 납품관리',
        },
        {
          subject: '수금',
          element:
            '수금관리, 수금자료 입력, 수금자료 검색, 기간별 수금 현황, 매출처별 수금 현황, 구분별 수금 현황, 매출처별 종합수금 현황, 세금 계산서별 수금정리, 월별 거래처 수금 현황, 매출 거래처 원장, 외상 매출금 현황',
        },
        {
          subject: '종합인쇄',
          element:
            '종합품목별 매출현황, 품목별 월별 매출현황, 매출처 월별 매출현황, 매출처 매출 순위 현황, 품목별 매출순위 현황, 영업사원별 매출 분석, 종합품목별 매입현황,  품목별 월별 매입현황, 매입처별 매입분석, 매입처 매입 순위현황, 재고 현황,종합 수불 현황, 수불부, 종합 월별 입출고 현황,  종합 일별 입출고 현황, 종합 구분별 매출현황, 종합 구분별 입고 현황, 품목별 수익율 분석, 업체별 수익율 분석, 업체품목 수익율 분석',
        },
        {
          subject: '견적/계획',
          element:
            '견적서 신규입력, 견적서 검색정정판매계획 신규입력, 판매계획 검색정정, 월별 판매계획, 품목별 판매계획, 매출처별 판매계획 ,영업사원별 판매계획, 주별 판매 계획 입력, 월간 매출 현황, 월간 판매 현황 및 계획, 연간 판매 계획 입력, 각종 실적 비교 분석, 년간 실적 비교 분석',
        },
        {
          subject: '기타관리',
          element: '자료 백업, 마감정리, 전년 자료 입력, 공지사항 관리, KPI 지표 현황, 발주 EXCEL 잔량 정리',
        },
        {
          subject: '수지예산',
          element: '계정코드 등록, 수금 계획 입력, 지출 계획 입력, 일별 자금 내역서, 일일 자금 계획서, 월별 자금 계획서',
        },
      ],
    }
  },
}
</script>

<style scoped>
@import '../../../style/content.css';
tbody {
  display: inline-block;
}
.tg .tg-o57c {
  /* word-wrap: break-word; */
  display: inline-block;
  width: 316.3px;
  height: 50px;
  /* justify-items: center; */
  /* word-break: break-all; */
}
.product div a {
  font-size: 16px;
  color: #333;
}
.product div a:hover {
  color: rgb(144, 177, 202);
}
.product div img {
  margin: 30px 0;
}
</style>
